import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { AppTheme } from '../../../../styles/AppTheme'
import { ChatbotNodeMenu } from './ChatbotNodeMenu'
import { NODE_TYPE_AGENT, NODE_TYPE_CONTACT, NODE_TYPE_START_CHATBOT, NODE_TYPE_TEMPLATE } from './chatbotGraph'

export function chatbotNodeIcon(type) {
  if (type === NODE_TYPE_TEMPLATE) return 'wysiwyg'
  if (type === NODE_TYPE_CONTACT) return 'manage_accounts'
  if (type === NODE_TYPE_START_CHATBOT) return 'smart_toy'
  if (type === NODE_TYPE_AGENT) return 'psychology'
  return 'chat'
}

export function ChatbotNodeHeader(props) {
  const tone = props.tone === 'crm' ? 'crm' : 'wa'
  return (
    <div className={css(Styles.header)}>
      <span className={css(Styles.iconTile, tone === 'crm' ? Styles.iconTileCrm : Styles.iconTileWa)}>
        <i className={'material-icons-outlined ' + css(Styles.icon, tone === 'crm' ? Styles.iconCrm : Styles.iconWa)}>
          {props.icon}
        </i>
      </span>
      <span className={css(Styles.title)}>{props.title}</span>
      <div className={css(Styles.right)}>
        {props.isStartNode ? <span className={css(Styles.startBadge)}>Start</span> : null}
        <ChatbotNodeMenu
          onDelete={props.onDelete}
          onDuplicate={props.onDuplicate}
          onSetStartNode={props.onSetStartNode}
          onToggleDefault={props.onToggleDefault}
          defaultEnabled={props.defaultEnabled}
        />
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 6px 8px 10px',
    backgroundColor: AppTheme.secondaryBg,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    gap: 8,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
  },
  iconTile: {
    width: 22,
    height: 22,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
  },
  iconTileWa: {
    backgroundColor: '#e7ffdb',
  },
  iconTileCrm: {
    backgroundColor: '#F3F4F6',
  },
  icon: {
    fontSize: 14,
    lineHeight: 1,
  },
  iconWa: {
    color: '#111b21',
  },
  iconCrm: {
    color: AppTheme.primaryColor,
  },
  title: {
    fontSize: 13,
    fontWeight: 600,
    color: '#222222',
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  right: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flex: '0 0 auto',
  },
  startBadge: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    color: '#4B5563',
    backgroundColor: '#F3F4F6',
    lineHeight: '16px',
    padding: '1px 8px',
    borderRadius: 999,
  },
})
